import BaseService from './base.service'

const loginOptions = (u, p) => {
  return {
    method: 'POST',
    body: JSON.stringify({ username: u, password: p }),
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
  }
}

const logoutOptions = () => {
  return {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
  }
}

const registerOptions = (u, p, c) => {
  return {
    method: 'POST',
    body: JSON.stringify({ username: u, password: p, confirm: c }),
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
  }
}

const forgotPasswordOptions = (u) => {
  return {
    method: 'POST',
    body: JSON.stringify({ username: u }),
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'same-origin',
  }
}

const resetPasswordOptions = (u, p, c, t) => {
  return {
    method: 'POST',
    body: JSON.stringify({ username: u, password: p, confirm: c }),
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': t,
    },
    credentials: 'same-origin',
  }
}

const forgotPasswordTokenOptions = (u, t) => {
  return {
    method: 'POST',
    body: JSON.stringify({ username: u }),
    headers: {
      'Content-Type': 'application/json',
      'x-access-token': t,
    },
    credentials: 'same-origin',
  }
}

class AuthenticationService extends BaseService {
  async authenticate(username, password) {
    try {
      let response = await fetch(
        '/api/v1/login',
        loginOptions(username, password)
      )
      this.handleHttpErrors(response)
      let user = await response.json()
      if (user && user.email) {
        sessionStorage.setItem('user', JSON.stringify(user))
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    }
    return false
  }

  async authenticateJoinUsUser(username, password) {
    try {
      let response = await fetch(
        '/api/v1/joinus/login',
        loginOptions(username, password)
      )
      this.handleHttpErrors(response)
      let user = await response.json()
      if (user && user.email) {
        sessionStorage.setItem('user', JSON.stringify(user))
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    }
    return false
  }

  async registerJoinUsUser(username, password, confirm) {
    try {
      let response = await fetch(
        '/api/v1/joinus/registration',
        registerOptions(username, password, confirm)
      )
      this.handleHttpErrors(response)
      let user = await response.json()
      if (user && user.email) {
        sessionStorage.setItem('user', JSON.stringify(user))
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    }
    return true
  }

  async forgotJoinUsPassword(username) {
    try {
      let response = await fetch(
        '/api/v1/joinus/forgot_password',
        forgotPasswordOptions(username)
      )
      this.handleHttpErrors(response)
      let ack = await response.json()
      if (ack && ack.rspCode === 'ok') {
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    }
  }

  async resetJoinUsPassword(username, password, confirm, token) {
    try {
      let response = await fetch(
        '/api/v1/joinus/forgot_password/reset',
        resetPasswordOptions(username, password, confirm, token)
      )
      this.handleHttpErrors(response)
      let ack = await response.json()
      if (ack && ack.rspCode === 'ok') {
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    }
    return true
  }

  async validateForgotPasswordToken(username, token) {
    try {
      let response = await fetch(
        '/api/v1/joinus/forgot_password/validate',
        forgotPasswordTokenOptions(username, token)
      )
      this.handleHttpErrors(response)
      let ack = await response.json()
      if (ack && ack.rspCode === 'ok') {
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    }
  }

  getAuthenticatedUser() {
    let user = sessionStorage.getItem('user')
    if (user) {
        user = JSON.parse(user)
       return new User(user.username, user.email, user.role, user.firstName, user.lastName);
    }
    return null
  }

  /**
   * This method calls server to destroy session and clean local storage.
   * @returns {Promise.<boolean>} true if logout successful else false
   */
  async logOut() {
    try {
      let response = await fetch('/api/v1/logout', logoutOptions())
      this.handleHttpErrors(response)
      let ack = await response.json()
      if (ack && ack.rspCode === 'ok') {
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    } finally {
      sessionStorage.clear()
    }
    return false
  }

  async joinUsLogOut() {
    try {
      let response = await fetch('/api/v1/joinus/logout', logoutOptions())
      this.handleHttpErrors(response)
      let ack = await response.json()
      if (ack && ack.rspCode === 'ok') {
        return true
      }
    } catch (error) {
      this.handleHttpErrors(error)
    } finally {
      sessionStorage.clear()
    }
    return false
  }
}


const ROLE_ADMIN = 'Administrator'

const ROLE_SUPERVISOR = 'Supervisor'

const ROLE_GENUSER = 'Data Entry'

class User {

    constructor(username, email, role, firstName, lastName) {
        this.username = username;
        this.role = role;
        this.email = email;
        this.firstName = firstName;
        this.lastName = lastName;
    }

    hasRole(roles){
        var found = false;
        for ( const role of roles){
            if (role === this.role) {
                found = true;
                return true;
            }
        }
        return found;
    }

    isFolderOwner(folder) {
        if (folder && folder.securityDetail) {
            return folder.securityDetail.owner == this.username;
        }
        return false;
    }

    isAdmin(){
        return this.role === ROLE_ADMIN
    }

    isSupervisor() {
        return this.role === ROLE_SUPERVISOR
    }

    isGeneralUser() {
        return this.role === ROLE_GENUSER
    }
}

const authService = new AuthenticationService()

export default authService
